<template>
  <div class="inquiry-page-wrapper">
    
    <!-- 1. Header / Navbar (مبسط) -->
    <nav class="navbar navbar-dark bg-primary-gradient shadow-sm">
        <div class="container">
            <a class="navbar-brand fw-bold d-flex align-items-center" href="#">
                <i class="fas fa-id-card-alt me-2 text-gold"></i>
                <span>بوابة أرقام الجلوس</span>
            </a>
            <router-link to="/" class="btn btn-outline-light btn-sm">العودة للرئيسية</router-link>
        </div>
    </nav>

    <!-- 2. Search Section -->
    <div class="container py-5 no-print">
        <div class="alert alert-info border-info border-2 shadow-sm d-flex align-items-center" role="alert">
    <div class="flex-shrink-0">
      <i class="fas fa-info-circle fa-2x text-info"></i>
    </div>
    <div class="flex-grow-1 ms-3">
      <h6 class="alert-heading fw-bold mb-1">ضوابط إتاحة أرقام الجلوس</h6>
      <p class="mb-0 small text-dark">
        يتم تفعيل خدمة الاستعلام وطباعة أرقام الجلوس <strong>فورياً</strong> بمجرد إتمام المدرسة لتسليم الاستمارات الورقية واعتمادها من <u>لجنة التنظيم والإدارة</u>.
      </p>
    </div>
  </div>
        <div class="row justify-content-center">
            <div class="col-lg-8 text-center" data-aos="fade-down">
                <h2 class="fw-bold text-primary-dark mb-3">الاستعلام عن مقر اللجنة ورقم الجلوس</h2>
                <p class="text-muted mb-4">أدخل الرقم القومي للطالب لعرض بطاقة رقم الجلوس وجدول الامتحانات</p>
                
                <form @submit.prevent="handleSearch" class="search-box shadow-lg p-4 bg-white rounded-3 border-top-gold">
                    <div class="input-group input-group-lg">
                        <span class="input-group-text bg-light border-end-0 text-primary">
                            <i class="fas fa-search"></i>
                        </span>
                        <input 
                            type="text" 
                            class="form-control border-start-0 bg-light" 
                            placeholder="اكتب الرقم القومي للطالب هنا..." 
                            v-model="searchQuery" 
                            required
                        >
                        <button class="btn btn-primary px-4 fw-bold" type="submit" :disabled="loading">
                            <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
                            بحث
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- 3. Results Section -->
    <div v-if="student" class="container pb-5" id="printMe">
        
        <!-- Action Bar -->
        <div class="d-flex justify-content-between align-items-center mb-4 d-print-none no-print">
            <h4 class="fw-bold border-end border-4 border-primary pe-3 m-0">بيانات الطالب</h4>
            <button @click="print" class="btn btn-info btn-lg text-dark fw-bold shadow-sm ">
                <i class="fas fa-print me-2"></i> طباعة بطاقة رقم الجلوس
            </button>
        </div>

        <!-- A. The Advanced Seating Card (تصميم البطاقة للطباعة) -->
       <div class="card-print-wrapper mb-5" id="printableCard">
    <div class="seating-card shadow-sm">
        <!-- خلفية زخرفية -->
        <div class="card-pattern"></div>
        
        <!-- الترويسة -->
        <div class="card-header-custom p-3 border-bottom">
    <div class="row align-items-center g-3 text-center text-md-start">
        
        <!-- اللوجو (يمين) -->
        <div class="col-3 col-md-2 text-center">
            <img src="/img/logo/edu.png" alt="Logo" class="card-logo">
        </div>
        
        <!-- العناوين (وسط) -->
        <div class="col-6 col-md-8 text-center">
            <h6 class="mb-1 fw-bold text-secondary small">محافظة شمال سيناء - مديرية التربية والتعليم</h6>
            <h4 class="mb-1 fw-bold text-primary-dark">بطاقة رقم جلوس الطالب</h4>
            <h6 class="mb-0 small text-muted bg-light d-inline-block px-3 py-1 rounded-pill border">
                إتمام مرحلة التعليم الأساسي 2026
            </h6>
        </div>
        
        <!-- ============================================ -->
        <!-- صورة الطالب (يسار - مكان الـ QR القديم) -->
        <!-- ============================================ -->
        <div class="col-3 col-md-2 text-center">
            <div class="student-photo-box mx-auto shadow-sm">
                <!-- 
                   مصدر الصورة: 
                   1. إذا كانت الصورة موجودة في قاعدة البيانات (student.image_path)
                   2. وإلا نستخدم صورة افتراضية (avatar.png)
                -->
                <img 
                    :src="student.image_path || '/img/467383910.jpg'" 
                    alt="صورة الطالب" 
                    class="student-img img-fluid"
                   
                >
            </div>
        </div>
        <!-- ============================================ -->

    </div>
</div>

        <!-- جسم البطاقة -->
        <div class="card-body-custom p-3 p-md-4">
            <div class="row g-4">
                
                <!-- 1. البيانات الأساسية (يمين) -->
                <div class="col-12 col-md-8 order-2 order-md-1">
                    <div class="student-info-group">
                        <div class="info-row d-flex flex-column flex-sm-row mb-2 border-bottom pb-2">
                            <span class="label text-muted ms-2"><i class="far fa-user me-1"></i> اسم الطالب:</span>
                            <span class="value fw-bold text-dark fs-5">{{ student.Arabic_Name }}</span>
                        </div>
                        
                        <div class="info-row d-flex flex-column flex-sm-row mb-2 border-bottom pb-2">
                            <span class="label text-muted ms-2"><i class="fas fa-school me-1"></i> المدرسة:</span>
                            <span class="value fw-bold">{{ student.School_Name }}</span>
                        </div>

                        <div class="row g-2">
                            <div class="col-6">
                                <div class="info-item bg-light p-2 rounded">
                                    <span class="d-block text-muted small">الديانة</span>
                                    <span class="fw-bold">{{ student.Moslem_Name }}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="info-item bg-light p-2 rounded">
                                    <span class="d-block text-muted small">اللغة</span>
                                    <span class="fw-bold">--</span> <!-- أو المتغير الخاص باللغة -->
                                </div>
                            </div>
                        </div>
                        <div class="row g-2 mt-2">
                                  <div class="col-6">
                <div class="info-item bg-light p-2 rounded h-100 border-start border-4" 
                     :class="student.Stud_Type_Id == 2 ? 'border-secondary' : 'border-success'">
                    <span class="d-block text-muted small mb-1">نظام القيد</span>
                    
                    <!-- عرض مميز للمنازل -->
                    <span v-if="student.Stud_Type_Id == 2" class="badge bg-secondary">منازل</span>
                    <span v-else class="fw-bold text-success">نظامي</span>
                </div>
            </div>

            <!-- حالة الطالب (منقول / باق / مستجد) -->
            <div class="col-6">
                <div class="info-item bg-light p-2 rounded h-100">
                    <span class="d-block text-muted small mb-1">حالة الطالب</span>
                    <span class="fw-bold text-primary-dark">
                        {{ student.Student_Case }} 
                        <!-- مثال: مستجد / باقي للإعادة -->
                    </span>
                </div>
            </div>
                        </div>
                    </div>
                </div>

                <!-- 2. رقم الجلوس واللجنة (يسار) -->
                <div class="col-12 col-md-4 order-1 order-md-2">
                    <div class="seat-committee-wrapper h-100 d-flex flex-column justify-content-center align-items-center bg-light-blue p-3 rounded-3 border border-primary-subtle">
                        
                        <!-- رقم الجلوس -->
                        <div class="seat-number-box text-center mb-3 w-100">
                            <span class="d-block text-primary fw-bold small mb-1">رقم الجلوس</span>
                            <div class="seat-value display-6 fw-bold text-dark bg-white border border-2 border-primary rounded py-1 shadow-sm">
                                {{ student.Seating_No }}
                            </div>
                        </div>

                        <!-- اللجنة -->
                        <div class="committee-box text-center w-100 border-top border-secondary pt-3 mt-1">
                            <h6 class="text-primary fw-bold mb-1">مقر اللجنة</h6>
                            <div class="committee-name fw-bold mb-1">{{ student.Commite_Name }}</div>
                            <span class="badge bg-primary rounded-pill px-3">لجنة رقم ({{ student.committee_id }})</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- التذييل والتوقيع -->
        <div class="card-footer-custom p-3 border-top bg-light rounded-bottom">
            <div class="row align-items-center gy-3">
                <div class="col-12 col-md-8 text-center text-md-start">
                    <div class="alert alert-warning d-flex align-items-center p-2 mb-0 border-warning small">
                        <i class="fas fa-exclamation-triangle text-danger fs-4 me-2"></i>
                        <div>
                            <strong>تنبيه هام:</strong> يمنع منعاً باتاً اصطحاب الهاتف المحمول، ويجب الحفاظ على هذه البطاقة.
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-4 text-center">
                    <div class="signature">
                        <p class="mb-0 small fw-bold text-muted">رئيس لجنة النظام والمراقبة</p>
                        <img :src="'img/signature.png'" alt="Signature" class="sig-img mt-1" style="height: 56px;opacity: 0.8;width: 155px;">
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>

        <!-- B. Exam Schedule (جدول الامتحانات - للعرض فقط) -->
         <div class="schedule-section no-print mb-5">
    <div class="d-flex align-items-center mb-3">
        <div class="icon-box bg-primary-subtle text-primary rounded-circle p-2 ms-2">
            <i class="fas fa-clock fa-lg"></i>
        </div>
        <h5 class="fw-bold m-0 text-danger">جدول سير الامتحانات (المواد غير المضافة)</h5>
    </div>

    <div class="table-responsive">
      <table class="table custom-table">
        <thead>
          <tr>
            <th class="text-start pe-4">اليوم والتاريخ</th>
             <th>الفترة</th>
            <th>المادة</th>
            <th>التوقيت</th>
            <th>الزمن</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(exam, index) in schedule_1" :key="index">
            <!-- عمود التاريخ -->
            <td class="text-start pe-4">
               <div class="d-flex align-items-center">
                   <div class="date-icon me-2">
                       <i class="far fa-calendar-alt"></i>
                   </div>
                   <span class="fw-bold text-dark">{{ exam.date }}</span>
               </div>
            </td>
            <td class="text-start pe-4">
               
           
                   <span class="fw-bold text-danger">{{ exam.order }}</span>
               
            </td>
            <!-- عمود المادة -->
            <td>
                <span class="subject-badge">{{ exam.subject }}</span>
            </td>
            
            <!-- عمود الوقت (مدمج) -->
            <td>
                <div class="time-range">
                    <span class="time-start">{{ exam.start }}</span>
                    <i class="fas fa-arrow-left text-muted mx-2 small"></i>
                    <span class="time-end">{{ exam.end }}</span>
                </div>
            </td>
            
            <!-- عمود الزمن -->
            <td>
                <span class="duration-text"><i class="far fa-hourglass me-1"></i> {{ exam.duration }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
       
       
               <div class="schedule-section no-print mb-5">
    <div class="d-flex align-items-center mb-3">
        <div class="icon-box bg-primary-subtle text-primary rounded-circle p-2 ms-2">
            <i class="fas fa-clock fa-lg"></i>
        </div>
        <h5 class="fw-bold m-0 text-success">جدول سير الامتحانات</h5>
    </div>

    <div class="table-responsive">
      <table class="table custom-table">
        <thead>
          <tr>
            <th class="text-start pe-4">اليوم والتاريخ</th>
            <th>الفترة</th>
            <th>المادة</th>
            <th>التوقيت</th>
            <th>الزمن</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(exam, index) in schedule" :key="index">
            <!-- عمود التاريخ -->
            <td class="text-start pe-4">
               <div class="d-flex align-items-center">
                   <div class="date-icon me-2">
                       <i class="far fa-calendar-alt"></i>
                   </div>
                   <span class="fw-bold text-dark">{{ exam.date }}</span>
               </div>
            </td>
            <td class="text-start pe-4">
               
           
                   <span class="fw-bold text-danger">{{ exam.order }}</span>
               
            </td>
            
            <!-- عمود المادة -->
            <td>
                <span class="subject-badge">{{ exam.subject }}</span>
            </td>
            
            <!-- عمود الوقت (مدمج) -->
            <td>
                <div class="time-range">
                    <span class="time-start">{{ exam.start }}</span>
                    <i class="fas fa-arrow-left text-muted mx-2 small"></i>
                    <span class="time-end">{{ exam.end }}</span>
                </div>
            </td>
            
            <!-- عمود الزمن -->
            <td>
                <span class="duration-text"><i class="far fa-hourglass me-1"></i> {{ exam.duration }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
 </div>

    <!-- 4. Error / Not Found Message -->
    <div v-if="error" class="container text-center py-5 no-print">
        <div class="alert alert-danger shadow-sm d-inline-block px-5">
            <i class="fas fa-exclamation-circle me-2"></i> {{ error }}
        </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
export default {
    name: 'SeatingInquiry',
    data() {
        return {
            // students:'',
            searchQuery: '',
            loading: false,
            student: '',
            error: null,
            // جدول امتحانات افتراضي (يمكن جلبه من API)
            schedule_1: [
              
                { date: 'الخميس 15/01/2026', subject: 'التربية الفنية ', start: '09:00', end: '11:00', duration: 'ساعتان' , order:'اﻻولى' },
                { date: 'الخميس 15/01/2026', subject: ' الكمبيوتر وتكنولوجيا المعلومات', start: '11:30', end: '12:30', duration: 'ساعتان' , order:'الثانية'  },
            ],
            schedule: [
                { date: 'السبت 17/01/2026', subject: 'اللغة العربية والخط', start: '09:00', end: '11:30', duration: 'ساعتان ونصف' , order:'اﻻولى'},
                { date: 'السبت 17/01/2026', subject: ' التربية الدينية', start: '12:00', end: '01:30', duration: 'ساعة ونصف' , order:'الثانية' },
                { date: 'الأحد 18/01/2026', subject: ' العلوم', start: '09:00', end: '11:00', duration: 'ساعتان', order:'اﻻولى' },
                { date: 'الثلاثاء 20/01/2026', subject: ' الهندسة', start: '09:00', end: '11:00', duration: 'ساعتان' , order:'اﻻولى'},
                { date: 'الثلاثاء 20/01/2026', subject: ' الدراسات اﻻجتماعية', start: '11:30', end: '01:30', duration: 'ساعتان', order:'الثانية' },
                { date: 'الاربعاء 21/01/2026', subject: ' الجبر واﻻحصاء', start: '09:00', end: '11:00', duration: 'ساعتان' , order:'اﻻولى' },
                { date: 'الخميس 22/01/2026', subject: 'اللغة اﻻنجليزية', start: '09:00', end: '11:00', duration: 'ساعتان' , order:'اﻻولى'},
            ]
        }
    },
    methods: {


    async handleSearch() {
        // 1. تصفية البيانات القديمة وبدء التحميل
        this.loading = true;
        this.error = null;
        this.student = '';

        // 2. التحقق من صحة المدخلات قبل الإرسال (Client-side Validation)
        // التأكد أنه رقم وليس حروف، وأن الطول لا يقل عن 14 رقم (للرقم القومي المصري)
        if (!this.searchQuery || isNaN(this.searchQuery) ) {
            this.error = "يرجى إدخال رقم قومي صحيح مكون من 14 رقماً.";
            this.loading = false;
            return; // توقف ولا ترسل للسيرفر
        }

        try {
            // 3. إرسال الطلب الحقيقي
            const res = await api.get('/searchstudent/' + this.searchQuery);

            // 4. التحقق من أن الاستجابة تحتوي على بيانات الطالب
            if (res.data && res.data.student) {
                this.student = '';
                this.student = res.data.student;
            } else {
                // حالة نادرة: السيرفر رد بنجاح (200) ولكن لم يرسل بيانات الطالب
                this.error = "لم يتم العثور على بيانات لهذا الرقم .";
            }

        } catch (err) {
            console.log(err);
            
             if (err.response && err.response.status === 403) {
           this.error = "عفواً، هذه الخدمة غير متاحة حالياً .";
           }else if (err.response && err.response.status === 404) {
                // الباك إند رد بـ 404 (غير موجود)
                this.error = "عفواً، هذا الرقم  غير مسجل بقاعدة البيانات، أو تأكد من صحة الرقم.";
            } else if (err.response && err.response.status === 500) {
                // خطأ في السيرفر
                this.error = "حدث خطأ في النظام، يرجى المحاولة لاحقاً.";
            } else {
                // خطأ انترنت أو غيره
                this.error = "فشل الاتصال بالخادم، يرجى التحقق من اتصال الإنترنت.";
                console.error(err);
            }
        } finally {
            // 6. إيقاف التحميل في كل الأحوال
            this.loading = false;
        }
    },
       print() {
      // Pass the element id here
      this.$htmlToPaper("printMe", () => {
        console.log("Printing done or got cancelled!");
      });
    },
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap');

/* 1. تنسيقات الكارت العامة */
.seating-card {
    position: relative;
    background-color: #fff;
    border: 2px solid #002147; /* إطار أزرق غامق */
    border-radius: 12px;
    overflow: hidden;
    max-width: 850px;
    margin: 0 auto;
}

/* خلفية مائية */
.card-pattern {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23002147' fill-opacity='0.03' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='3'/%3E%3Ccircle cx='13' cy='13' r='3'/%3E%3C/g%3E%3C/svg%3E");
    z-index: 0;
    pointer-events: none;
}

.card-logo {
    height: 70px;
    width: auto;
}

.bg-light-blue {
    background-color: #f0f7ff;
}

/* تحسين النصوص */
.text-primary-dark {
    color: #002147;
}

/* 2. تحسينات الموبايل (Media Queries) */
@media (max-width: 768px) {
    .card-header-custom h4 {
        font-size: 1.2rem; /* تصغير العنوان قليلاً */
    }
    .seat-value {
        font-size: 2rem; /* تصغير رقم الجلوس */
    }
    .info-row {
        flex-direction: column; /* البيانات تحت بعضها */
        align-items: flex-start;
    }
    .info-row .label {
        font-size: 0.85rem;
        margin-bottom: 2px;
    }
    .signature img {
        height: 30px;
    }
}

/* 3. تنسيقات الطباعة (Strict Layout) */
@media print {
    @page {
        size: A5 landscape; /* حجم مناسب لبطاقة الجلوس */
        margin: 0;
    }

    body * {
        visibility: hidden;
    }

    #printableCard, #printableCard * {
        visibility: visible;
    }

    #printableCard {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 95%; /* استخدام معظم مساحة الورقة */
        margin: 0;
        padding: 0;
    }

    .seating-card {
        border: 2px solid #000 !important;
        box-shadow: none !important;
        width: 100%;
    }

    /* إجبار المتصفح على استخدام تخطيط الصفوف (Grid) حتى لو طبعنا من الموبايل */
    .col-md-2 { width: 16.66% !important; float: right; }
    .col-md-8 { width: 66.66% !important; float: right; }
    .col-md-4 { width: 33.33% !important; float: right; }
    
    /* إعادة ترتيب العناصر للطباعة (رقم الجلوس على اليسار) */
    .order-md-1 { order: 1 !important; }
    .order-md-2 { order: 2 !important; }

    /* إظهار الخلفيات والألوان */
    .bg-light, .bg-light-blue, .alert-warning {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    
    .btn { display: none !important; }
}

.student-photo-box {
    width: 90px;  /* عرض مناسب للطباعة */
    height: 110px; /* نسبة 4:6 تقريباً */
    border: 1px solid #ccc;
    padding: 3px;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
}

.student-img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* لضمان عدم مط الصورة */
    border-radius: 2px;
}



</style>
